/* eslint-disable camelcase */
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import services from './remoteServices';
import {Design} from '../models/design';

export type DesignsParamsType = {
  email: string;
  page: number;
};

export type DesignsResponseType = {
  designs: Design[];
  total_count: number;
  page: number;
  per_page: number;
  total_pages: number;
};

export const designsApi = createApi({
  reducerPath: 'designsApi',
  baseQuery: fetchBaseQuery({baseUrl: services.designs}),
  endpoints: builder => ({
    fetchDesigns: builder.query<DesignsResponseType, DesignsParamsType>({
      query: (params: DesignsParamsType) => ({
        url: `?api_version=2&email=${params.email}&page=${params.page}&per_page=8`,
        headers: {
          'Content-Type': 'application/json'
        }
      }),
      transformResponse: (response: DesignsResponseType) => {
        return response;
      }
    }),
    getDesign: builder.query<Design, string>({
      query: (id: string) => ({
        url: `/${id}?api_version=5`,
        headers: {
          'Content-Type': 'application/json'
        },
        providesTags: ['Design']
      })
    })
  })
});

export const {useFetchDesignsQuery, useLazyGetDesignQuery} = designsApi;
